import { throwError as observableThrowError, Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { FacultyMedicalProcedureCategoryModel } from '../model/faculty_medical_procedure_category.model';
import { TraineeMedicalProcedureCaseModel } from '../model/trainee_medical_procedure_case.model';
import { FacultyMedicalProcedureParameterModel } from '../model/faculty_medical_procedure_parameter';
import { TraineeMedicalProcedureModel } from '../model/trainee_medical_procedure.model';
import { TraineeMedicalProcedureCaseCreateModel } from '../model/trainee_medical_procedure_case_create.model';
import { TrainerMedicalProcedureModel } from '../model/trainer_medical_procedure.model';
import { TrainerFacultyMedicalProcedureTraineesModel } from '../model/trainer_faculty_medical_procedure_trainees.model';
import { TraineeMedicalProcedureCaseParameterModel } from '../model/trainee_medical_procedure_case_parameter.model';
import { MedicalProcedureCaseParameterBase } from '../model/reactive-form-model/medical_procedure_case_parameter_base.model';
import { TraineeMedicalProcedureCaseReviewParameterModel } from '../model/trainee_medical_procedure_case_review_parameter.model';
import { TraineeMedicalProcedureCaseReviewCreateModel } from '../model/trainee_medical_procedure_case_review_create.model';
import { TraineeMedicalProcedureCaseReviewModel } from '../model/trainee_medical_procedure_case_review.model';
import { TraineeMedicalProcedureCaseAttachmentModel } from '../model/trainee_medical_procedure_case_attachment.model';

import { ProcedurePerformanceTypeModel } from '../model/procedure_performance_type.model';

import { API_URLS } from '../utils/api_url.util';
import { API_UTILS } from '../utils/api_utils.util';

import { TrainerApproveAllModel } from '../model/trainer_approve_all.model';
import { ApiResultModel } from '../model/api_result.model';
import { catchError, map, tap } from 'rxjs/operators';
import { FacultyMedicalProcedureModel } from '../model/faculty_medical_procedure.model';
import { TraineeMedicalProcedureCaseDetailsModule } from '../pages/user/trainee-medical-procedure-case-details/trainee-medical-procedure-case-details.module';

/*
  Generated class for the UserFaculties provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class MedicalProcedureService {
	constructor(private http: HttpClient) {}

	getPerformanceTypes(): Observable<Array<ProcedurePerformanceTypeModel>> {
		let items$ = this.http
			.get<Array<ProcedurePerformanceTypeModel>>(API_URLS.API_GET_MEDICAL_PROCEDURE_PERFORMANCE_TYPES)
			.pipe(catchError(handleError));
		return items$;
	}

	getFacultyMedicalProcedureCategoriesItems(
		facultyId: string,
		programCategoryId: number
	): Observable<Array<FacultyMedicalProcedureCategoryModel>> {
		let items$ = this.http
			.get<Array<FacultyMedicalProcedureCategoryModel>>(
				API_URLS.API_GET_FACULTY_MEDICAL_PROCEDURE_CATEGORIES + `/${facultyId}` + `/${programCategoryId}`
			)
			.pipe(catchError(handleError));
		return items$;
	}

	getFacultyMedicalProcedure(Id: string): Observable<FacultyMedicalProcedureModel> {
		let items$ = this.http
			.get<FacultyMedicalProcedureModel>(API_URLS.API_GET_FACULTY_MEDICAL_PROCEDURE + `/${Id}`)
			.pipe(catchError(handleError));
		return items$;
	}

	addFacultyMedicalProcedureCategoryItem(
		item: FacultyMedicalProcedureCategoryModel
	): Observable<FacultyMedicalProcedureCategoryModel> {
		let body = JSON.stringify(item);
		let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
		let options = { headers: headers };

		let items$ = this.http
			.post<FacultyMedicalProcedureCategoryModel>(
				API_URLS.API_ADD_FACULTY_MEDICAL_PROCEDURE_CATEGORY,
				body,
				options
			)
			.pipe(catchError(handleError));
		return items$;
	}

	editFcultyMedicalProcedureCategoryItem(
		item: FacultyMedicalProcedureCategoryModel
	): Observable<FacultyMedicalProcedureCategoryModel> {
		let body = JSON.stringify(item);
		let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
		let options = { headers: headers };
		let id = item.Id;

		let items$ = this.http
			.post<FacultyMedicalProcedureCategoryModel>(
				API_URLS.API_EDIT_FACULTY_MEDICAL_PROCEDURE_CATEGORY,
				body,
				options
			)
			.pipe(catchError(handleError));
		return items$;
	}

	removeItem(item: FacultyMedicalProcedureCategoryModel): Observable<FacultyMedicalProcedureCategoryModel> {
		let body = JSON.stringify(item);
		let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
		let options = { headers: headers };
		let id = item.Id;

		let items$ = this.http
			.get<FacultyMedicalProcedureCategoryModel>(
				API_URLS.API_REMOVE_FACULTY_MEDICAL_PROCEDURE_CATEGORY + `/${id}`
			)
			.pipe(catchError(handleError));
		return items$;
	}

	addTraineeMedicalProcedureCase(item: TraineeMedicalProcedureCaseCreateModel): Observable<ApiResultModel> {
		let body = JSON.stringify(item);
		let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
		let options = { headers: headers };

		let items$ = this.http
			.post<ApiResultModel>(API_URLS.API_POST_ADD_TRAINEE_MEDICAL_PROCEDURE_CASE, body, options)
			.pipe(catchError(handleError));
		return items$;
	}

	getTraineeMedicalProcedureCaseReviews(caseId: string): Observable<TraineeMedicalProcedureCaseReviewModel[]> {
		let items$ = this.http
			.get<TraineeMedicalProcedureCaseReviewModel[]>(
				API_URLS.API_GET_TRAINEE_MEDICAL_PROCEDURE_CASE_REVIEWS + `/${caseId}`
			)
			.pipe(catchError(handleError));
		return items$;
	}

	addTraineeMedicalProcedureCaseReview(
		item: TraineeMedicalProcedureCaseReviewCreateModel
	): Observable<ApiResultModel> {
		let body = JSON.stringify(item);
		let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
		let options = { headers: headers };

		let items$ = this.http
			.post<ApiResultModel>(API_URLS.API_POST_ADD_TRAINEE_MEDICAL_PROCEDURE_CASE_REVIEW, body, options)
			.pipe(catchError(handleError));
		return items$;
	}

	removeTraineeMedicalProcedureCaseReview(
		item: TraineeMedicalProcedureCaseReviewModel
	): Observable<TraineeMedicalProcedureCaseReviewModel> {
		let body = JSON.stringify(item);
		let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
		let options = { headers: headers };
		let id = item.Id;

		let items$ = this.http
			.post<TraineeMedicalProcedureCaseReviewModel>(
				API_URLS.API_REMOVE_TRAINEE_MEDICAL_PROCEDURE_CASE_REVIEW,
				body,
				options
			)
			.pipe(catchError(handleError));
		return items$;
	}

	approveTraineeMedicalProcedureCase(
		item: TraineeMedicalProcedureCaseModel
	): Observable<TraineeMedicalProcedureCaseModel> {
		let body = JSON.stringify(item);
		let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
		let options = { headers: headers };

		let items$ = this.http
			.post<TraineeMedicalProcedureCaseModel>(
				API_URLS.API_POST_APPROVE_TRAINEE_MEDICAL_PROCEDURE_CASE,
				body,
				options
			)
			.pipe(catchError(handleError));
		return items$;
	}

	editTraineeMedicalProcedureCase(item: TraineeMedicalProcedureCaseCreateModel): Observable<ApiResultModel> {
		let body = JSON.stringify(item);
		let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
		let options = { headers: headers };

		let items$ = this.http
			.post<ApiResultModel>(API_URLS.API_POST_UPDATE_TRAINEE_MEDICAL_PROCEDURE_CASE, body, options)
			.pipe(catchError(handleError));
		return items$;
	}

	getTrainerFacultyMedicalProcedure(userId: string): Observable<TrainerMedicalProcedureModel[]> {
		let items$ = this.http
			.get<TrainerMedicalProcedureModel[]>(API_URLS.API_GET_TRAINER_MEDICAL_PROCEDURES + `/${userId}`)
			.pipe(catchError(handleError));
		return items$;
	}

	getTrainerFacultyMedicalProcedureTrainees(
		userId: string,
		facultyProcedureId: string
	): Observable<TrainerFacultyMedicalProcedureTraineesModel[]> {
		let items$ = this.http
			.get<TrainerFacultyMedicalProcedureTraineesModel[]>(
				API_URLS.API_GET_TRAINER_MEDICAL_PROCEDURES_TRAINEES + `/${userId}` + `/${facultyProcedureId}`
			)
			.pipe(catchError(handleError));
		return items$;
	}

	//membership
	getTraineeMedicalProcedure(studentId: string, facultyId: string): Observable<TraineeMedicalProcedureModel[]> {
		let items$ = this.http
			.get<TraineeMedicalProcedureModel[]>(
				API_URLS.API_GET_STUDENT_MEDICAL_PROCEDURES + `/${studentId}` + `/${facultyId}`
			)
			.pipe(catchError(handleError));
		return items$;
	}

	//get procedures by fellowship
	getTraineeMedicalProcedureByFellowshipSpecialisation(
		studentId: string,
		facultyId: string,
		specialisationId: string
	): Observable<TraineeMedicalProcedureModel[]> {
		let items$ = this.http
			.get<TraineeMedicalProcedureModel[]>(
				API_URLS.API_GET_STUDENT_MEDICAL_PROCEDURES_BY_FELLOWSHIP_SPECIALISATION +
					`/${studentId}` +
					`/${facultyId}` +
					`/${specialisationId}`
			)
			.pipe(catchError(handleError));
		return items$;
	}

	getTraineeMedicalProcedureCases(
		facultyMedicalProcedureId: string,
		traineeId: string
	): Observable<TraineeMedicalProcedureCaseModel[]> {
		let items$ = this.http
			.get<TraineeMedicalProcedureCaseModel[]>(
				API_URLS.API_GET_TRAINEE_MEDICAL_PROCEDURE_CASES + `/${facultyMedicalProcedureId}` + `/${traineeId}`
			)
			.pipe(catchError(handleError));
		return items$;
	}

	getMedicalProcedureCasesReports(): Observable<Array<TraineeMedicalProcedureCaseModel>> {
		let items$ = this.http
			.get<Array<TraineeMedicalProcedureCaseModel>>(API_URLS.API_GET_MEDICAL_PROCEDURE_CASES_REPORT)
			.pipe(catchError(handleError));
		return items$;
	}

	getTrainerTraineeProcedureCases(
		trainerId: string,
		traineeId: string
	): Observable<Array<TraineeMedicalProcedureCaseModel>> {
		let items$ = this.http
			.get<Array<TraineeMedicalProcedureCaseModel>>(
				API_URLS.API_GET_TRAINER_TRAINEE_MEDICAL_PROCEDURE_CASES + `/${trainerId}` + `/${traineeId}`
			)
			.pipe(catchError(handleError));
		return items$;
	}

	getTraineeMedicalProcedureCaseAttachments(
		caseId: string
	): Observable<TraineeMedicalProcedureCaseAttachmentModel[]> {
		let items$ = this.http
			.get<TraineeMedicalProcedureCaseAttachmentModel[]>(
				API_URLS.API_GET_TRAINEE_MEDICAL_PROCEDURE_CASE_ATTACHMENTS + `/${caseId}`
			)
			.pipe(catchError(handleError));
		return items$;
	}

	removeTraineeMedicalCaseTachment(
		item: TraineeMedicalProcedureCaseAttachmentModel
	): Observable<TraineeMedicalProcedureCaseAttachmentModel> {
		let body = JSON.stringify(item);
		let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
		let options = { headers: headers };
		let id = item.Id;

		let items$ = this.http
			.post<TraineeMedicalProcedureCaseAttachmentModel>(
				API_URLS.API_REMOVE_TRAINEE_MEDICAL_PROCEDURE_CASE_ATTACHMENT,
				body,
				options
			)
			.pipe(catchError(handleError));
		return items$;
	}

	addTraineeMedicalProcedureCaseAttachment(
		item: TraineeMedicalProcedureCaseAttachmentModel
	): Observable<TraineeMedicalProcedureCaseAttachmentModel> {
		let body = JSON.stringify(item);
		let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
		let options = { headers: headers };

		let items$ = this.http
			.post<TraineeMedicalProcedureCaseAttachmentModel>(
				API_URLS.API_ADD_TRAINEE_MEDICAL_PROCEDURE_CASE_ATTACHMENTS,
				body,
				options
			)
			.pipe(catchError(handleError));
		return items$;
	}

	getTraineeMedicalProcedureCaseItem(caseId: string): Observable<TraineeMedicalProcedureCaseModel> {
		let items$ = this.http
			.get<TraineeMedicalProcedureCaseModel>(API_URLS.API_GET_TRAINEE_MEDICAL_PROCEDURE_CASE_ITEM + `/${caseId}`)
			.pipe(catchError(handleError));
		return items$;
	}

	approveAllTrainerTraineePendingProcedures(item: TrainerApproveAllModel): Observable<ApiResultModel> {
		let body = JSON.stringify(item);
		let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
		let options = { headers: headers };

		let items$ = this.http
			.post<ApiResultModel>(API_URLS.API_POST_APPROVE_TRAINER_TRAINEE_ALL_MEDICAL_PROCEDURE_CASE, body, options)
			.pipe(catchError(handleError));
		return items$;
	}

	getTraineeMedicalProcedureCaseParameters(caseId: string): Observable<TraineeMedicalProcedureCaseParameterModel[]> {
		let items$ = this.http
			.get<TraineeMedicalProcedureCaseParameterModel[]>(
				API_URLS.API_GET_TRAINEE_MEDICAL_PROCEDURE_CASE_PARAMETERS + `/${caseId}`
			)
			.pipe(catchError(handleError));
		return items$;
	}

	getFacultyMedicalProcedureParametersForNewCase(
		fmpId: string
	): Observable<TraineeMedicalProcedureCaseParameterModel[]> {
		let items$ = this.http
			.get<TraineeMedicalProcedureCaseParameterModel[]>(
				API_URLS.API_GET_FACULTY_MEDICAL_PROCEDURE_PARAMETERS_FOR_NEW_CASE + `/${fmpId}`
			)
			.pipe(catchError(handleError));
		return items$;
	}

	getFacultyMedicalProcedureCaseReviewParametersForNewReview(
		fmpId: string
	): Observable<TraineeMedicalProcedureCaseReviewParameterModel[]> {
		let items$ = this.http
			.get<TraineeMedicalProcedureCaseReviewParameterModel[]>(
				API_URLS.API_GET_FACULTY_MEDICAL_PROCEDURE_CASE_REVIEW_PARAMETERS_FOR_NEW_REVIEW + `/${fmpId}`
			)
			.pipe(catchError(handleError));
		return items$;
	}

	getFacultyMedicalProcedureParameters(id: string): Observable<TraineeMedicalProcedureCaseParameterModel[]> {
		let items$ = this.http
			.get<FacultyMedicalProcedureParameterModel[]>(
				API_URLS.API_GET_FACULTY_MEDICAL_PROCEDURE_PARAMETERS + `/${id}`
			)
			.pipe(
				catchError(handleError),
				map((fParams: Array<FacultyMedicalProcedureParameterModel>) => {
					// second map to transform to TraineeMedicalProcedureCaseParameterModel

					let traineeFMParams: TraineeMedicalProcedureCaseParameterModel[] = [];

					if (fParams) {
						fParams.forEach((element) => {
							let tParam = new TraineeMedicalProcedureCaseParameterModel();
							tParam.Id = null;
							tParam.ParameterName = element.Name;
							tParam.FacultyMedicalProcedureParameterId = element.Id;

							traineeFMParams.push(tParam);
						});
					}
					return traineeFMParams;
				})
			);
		return items$;
	}

	getTraineeMedicalProcedureActivityDetails(refNo: string): Observable<TraineeMedicalProcedureCaseModel> {
		let item$ = this.http
			.get<TraineeMedicalProcedureCaseModel>(
				API_URLS.API_GET_TRAINEE_MEDICAL_PROCEDURE_ACTIVITY_DETAILS + `/${refNo}`
			)
			.pipe(catchError(handleError));
		return item$;
	}

	//see https://angular.io/docs/ts/latest/cookbook/dynamic-form.html
	mDynamicCaseEditItemstoFormGroup(
		parameters: MedicalProcedureCaseParameterBase<any>[],
		caseItem: TraineeMedicalProcedureCaseModel
	) {
		let parametersGroup: any = {};

		let patientGroup: any = {
			PatientName: new FormControl(caseItem.PatientFullName, Validators.required),
			PatientAge: new FormControl(caseItem.PatientAge, Validators.required),
			PatientGender: new FormControl(caseItem.PatientGender, Validators.required),
			PatientCode: new FormControl(caseItem.PatientCode)
		};

		parameters.forEach((question) => {
			parametersGroup[question.key] = question.required
				? new FormControl(question.value || '', Validators.required)
				: new FormControl(question.value || '');
		});

		if(caseItem.IsPatientProcedure===true)
		return new FormGroup({
			patient: new FormGroup(patientGroup),
			parameters: new FormGroup(parametersGroup)
		});
		else
		return new FormGroup({
			parameters: new FormGroup(parametersGroup)
		});
	}

	//see https://angular.io/docs/ts/latest/cookbook/dynamic-form.html
	mDynamicCaseCreateItemstoFormGroup(parameters: MedicalProcedureCaseParameterBase<any>[],isPatientProcedure) {

		
		let parametersGroup: any = {};

		let trainerGroup: any = {
			TrainerId: new FormControl('', Validators.required)
		};

		let patientGroup: any = {
			PatientName: new FormControl('', Validators.required),
			PatientAge: new FormControl('', Validators.required),
			PatientGender: new FormControl('', Validators.required),
			PatientCode: new FormControl('')
		};

		parameters.forEach((question) => {
			parametersGroup[question.key] = question.required
				? new FormControl(question.value || '', Validators.required)
				: new FormControl(question.value || '');
		});

		if(isPatientProcedure==true)
		return new FormGroup({
			hospitalId: new FormControl('', Validators.required),
			procedurePerformanceTypeId: new FormControl('', Validators.required),
			trainer: new FormGroup(trainerGroup),
			patient: new FormGroup(patientGroup),
			parameters: new FormGroup(parametersGroup)
		});
		else
		return new FormGroup({
			hospitalId: new FormControl('', Validators.required),
			procedurePerformanceTypeId: new FormControl('', Validators.required),
			trainer: new FormGroup(trainerGroup),
			parameters: new FormGroup(parametersGroup)
		});
	}

	//see https://angular.io/docs/ts/latest/cookbook/dynamic-form.html
	mDynamicCaseReviewCreateItemstoFormGroup(parameters: MedicalProcedureCaseParameterBase<any>[]) {
		let parametersGroup: any = {};

		parameters.forEach((question) => {
			parametersGroup[question.key] = question.required
				? new FormControl(question.value || '', Validators.required)
				: new FormControl(question.value || '');
		});

		return new FormGroup({
			ReviewDate: new FormControl('', Validators.required),
			parameters: new FormGroup(parametersGroup)
		});
	}
}

// this could also be a private method of the component class
function handleError(error: HttpErrorResponse) {
	// log error
	// could be something more sofisticated
	console.error(error);

	return observableThrowError(error.error);
}
